module.exports = __webpack_public_path__ + "static/img/vision_values_pt.6e159156.png";